"use strict";
/**
 * @file 工具方法
 * @author Auto Generated by CommonFile
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.line2UpperCase = exports.createClsName = void 0;
var config_1 = require("../config");
/**
 * 创建 class name
 */
var createClsName = function (name) {
    return "".concat(config_1.CLASS_NAME_PREFIX, "-").concat(name);
};
exports.createClsName = createClsName;
/**
 * 横线格式名称转大驼峰
 * @param text 横线格式名称
 */
var line2UpperCase = function (text) {
    return text.replace(/(^\w|-\w)/g, function (c) { return c.slice(-1).toUpperCase(); });
};
exports.line2UpperCase = line2UpperCase;
